import React from 'react';
import { parseEntities } from 'parse-entities';
import classNames from 'classnames';

interface Props {
  title: string;
  titleClass?: string;
  titleNumber?: string;
  isInOutstandingWrapper?: boolean;
}

export const TitleSecond = ({ title, titleClass = '', titleNumber, isInOutstandingWrapper = false }: Props) => {
  const containerClasses = classNames('h1-title', titleClass, {
    'in-outstanding-container': isInOutstandingWrapper,
  });

  return titleNumber ? (
    <div className="title-with-number">
      {titleNumber && <span>{titleNumber} </span>} <h2 className={containerClasses}> {parseEntities(title)}</h2>
    </div>
  ) : (
    <h2 className={containerClasses}> {parseEntities(title)}</h2>
  );
};
